import {
    enumIsEnumValue,
    enumReduce,
    evaluateFunction,
    objectFilterEntries,
    objectGetKeys,
    objectGetValues,
    objectPick,
    PickByValue,
    Values
} from '@wix/devzai-utils-common';
import {
    WixPremiumBillingCycle,
    wixPremiumBooleanFeatureIsEnabled,
    WixPremiumCycleIntervalUnit,
    WixPremiumFeaturesStatus,
    WixPremiumFeatureStatus,
    WixPremiumFeatureType,
    WixPremiumProductId,
    WixPremiumProductsPricing,
    wixPremiumQuotaFeatureGetLimit,
    wixPremiumQuotaFeatureGetRemainedQuota
} from '@wix/devzai-common-wix';
import {DoppePremiumActiveDistinguishingFeature, DoppePremiumFeaturesSpec} from './doppe-premium-features';
import {DoppeDtoPremiumFeatureCatalogInfo} from '../types';

export type DoppePremiumOrderPageData = {
    userEmail: string;
    orderSessionId: string;
    riskCheckIframeUrl?: string;
    eventAggregator: string;
}

export const DoppePremiumProductsTypeId = '9c7a270d-c9f2-41bf-bb56-e6543c6b0008';

export const DoppePremiumProductsDev = {
    Infinity: '9b420267-ca3e-4cc0-b169-28e876adeb0d'
} as const;

export const DoppePremiumProducts = {
    HoppNewFreeTrialBrand_DONT_USE: 'c07668f1-8464-4388-a524-699671b5b54f',
    HoppNewFreeTrialBusiness_DONT_USE: 'c12be63d-bbc3-4b8b-b4fd-bb13b4c93408', // '9d1ad7ed-78e4-48c8-841d-ffce4c6cbd9c'
    HoppNewFreeTrialBusinessPro_DONT_USE:  'c5991ee6-799b-4ef4-a711-36a89b575859', // 'dc63fa49-6ca3-40fa-be20-42dc4af6e8c5'
    WixLiteStarter1_DONT_USE: 'f20cd604-2c3d-448c-9407-1e7304e24853',
    WixLiteWebsiteCheapFreeTrial2_DONT_USE: '06caaabc-879a-4490-8250-b198ba83d597',
    WixLiteBusinessCheapFreeTrial3_DONT_USE: '633048d3-b8b6-47c5-b3e4-7f665a6e7428',
    WixLiteWebsiteMediumFreeTrial1_DONT_USE: 'd6422444-9973-4ad0-975e-f00725397060',
    WixLiteBusinessMediumFreeTrial2_DONT_USE: '79573582-c7e3-45ae-bf21-9a02abde78d1',
    WixLiteBusinessEliteMediumFreeTrial3_DONT_USE: '65692b72-b5c8-45f7-92ce-c23715390308',
    Tier1_DONT_USE: '3eb0990a-93e7-41db-8829-28ab32a105e3',
    Tier2_DONT_USE: '4fb355bd-8151-4df3-bec0-84ac6a9867ce',
    Tier3_DONT_USE: '84073c0c-cdaf-4169-a5d6-c8829971fada',
    FreeTrial14DaysBasic_DONT_USE: '109afc22-17bc-4d7d-bda1-fc7a8428765e',
    FreeTrial14DaysUltimate_DONT_USE: 'd7f07133-c20d-441a-8428-5aba294eb28f',
    FreeTrial14DaysVIP_DONT_USE: 'fe4f93bb-c4ce-4437-9d68-758db7dc3007',


    Starter: '270041d1-81b3-4b07-be41-06fbd38edbad',
    NameComProTest: 'ece1673b-20b3-48f9-9271-74ad50bca8f0',
    ProBrandMaker: 'f37b13d1-e25a-4479-a65c-45fd5742f6b3',
    ProBrandMakerWithDomain: '3667d7c4-d6d0-4f9e-9bab-ff2e384a30e0',
    Pro: 'c1be10e7-b2d3-4e1f-99a3-34eff5478810',
    ProWithOutDomain: '3a3b641e-270d-48ac-b9bf-e5ebfca5ee57',
    IsracardVip: '38b8b8c4-57b6-496f-a8ba-48ec0ba5307c',
    Tier1: '9da061b6-b78a-4296-9d6d-df076a3a2896',
    Tier2: '156ca4ba-d489-4e78-b516-163944c683e1',
    Tier3: '7415c38b-91f2-4a23-a82e-81962589d829',
    FreeTrial14DaysBasic: '1f46a7f0-6f0e-4274-b413-bea2688e9065',
    FreeTrial14DaysUltimate: 'f7b685e0-46cd-4c1e-986d-4ac2f3757582',
    FreeTrial14DaysVIP: '03601204-5cb1-41d3-9b5a-083055e51029',
    WixBusinessTest: '7fe22abe-1001-4b50-a4b1-e9d85ff7f369',
    WixBusinessEliteTest: '421671d8-5681-4227-af92-11be3218d164',
    WixLiteCore1: '203e1bda-2fba-4ce7-aa70-3e5fb6b5351f',
    WixLiteBusiness2: '1e2c9bc5-0e9b-4186-89a8-1da9d65d6cfd',
    WixLiteBusinessElite3: '12262ac8-c73d-4a9f-b626-4f6088e20b08',
    WixLiteFreeTrialCore1: 'bd00e87e-8f47-48a9-b63e-db7e8dff9755',
    WixLiteFreeTrialBusiness2: 'a8f83eff-a9b4-4bf1-9bcc-6f1327b48d15',
    WixLiteFreeTrialBusinessElite3: '71b58578-b602-4ba0-b0b9-a54c13b873d3',
    HoppNewFreeTrialBrand: '2fa679ab-3c07-414e-8f14-5497d4c3cf1c',
    HoppNewFreeTrialBusiness: '90d1ddd6-03e7-4afb-b3ba-6416cc854287',
    HoppNewFreeTrialBusinessPro:  'f7cca58a-46fe-4c19-8342-cf5d0afa8321',

    WixLiteStarter1: 'cb01de62-d410-48e3-83f9-2ceed0b054c5',
    WixLiteWebsiteCheapFreeTrial2: '92311629-5d03-414d-96f6-703e0ccbdf97',
    WixLiteBusinessCheapFreeTrial3: '550f11e5-a5ae-485f-b835-affa4a40caac',
    WixLiteWebsiteMediumFreeTrial1: '3aef520f-6586-460b-b587-36fbf292cb9c',
    WixLiteBusinessMediumFreeTrial2: '68095bbf-133a-4701-91d7-cd981e83b70c',
    WixLiteBusinessEliteMediumFreeTrial3: 'efd1847b-dc1c-4ea4-b868-7911589f64b3',

    HoppNewFreeTrial14Brand: '5e4b4015-e41d-4f76-b7fe-c29448f94408',
    HoppNewFreeTrial14Business: '4778a8b9-f0ec-4a02-836c-9cd935b5fa49',
    HoppNewFreeTrial14BusinessPro:  '209171c0-606a-480d-9639-77b12eb40fc1',

    HoppNewFreeTrial7Brand: '634894bc-4a21-4a9f-a5fb-fa0db350924e',
    HoppNewFreeTrial7BrandShowcase: "d16acd20-ac1b-4a4e-9dc2-93f6db4ffbb6",
    HoppNewFreeTrial7BrandHigherPrice: "d516d3e9-deaa-4b5b-9fb4-50143aa926f6",
    HoppNewFreeTrial7Business: 'f33c30d9-0133-43cc-a6d9-857b3443a129',
    HoppNewFreeTrial7BusinessPro:  'ab872b98-d6e8-4ab3-af2f-788c7548fb2f',

    WixLiteStarterHigh: 'eaf19c0e-d93e-43be-b26f-8e2c7575c21e',
    WixLiteWebsiteHigh14: '720817b3-98e8-4145-a3ad-c444127cbac6',
    WixLiteBusinessHigh14: 'ef53fc39-dbd0-4a47-82dc-e3d5f33982dd',

    ...DoppePremiumProductsDev
} as const;

export type DoppePremiumProducts = Values<typeof DoppePremiumProducts>;

export const DoppeMainPremiumProducts = enumReduce(DoppePremiumProducts, [
    DoppePremiumProducts.Pro,
    DoppePremiumProducts.Tier1,
    DoppePremiumProducts.Tier2,
    DoppePremiumProducts.Tier3,
    DoppePremiumProducts.IsracardVip,
    DoppePremiumProducts.FreeTrial14DaysBasic,
    DoppePremiumProducts.FreeTrial14DaysUltimate,
    DoppePremiumProducts.FreeTrial14DaysVIP,
    DoppePremiumProducts.Infinity,
    DoppePremiumProducts.HoppNewFreeTrialBrand,
    DoppePremiumProducts.HoppNewFreeTrialBusiness,
    DoppePremiumProducts.HoppNewFreeTrialBusinessPro,
    DoppePremiumProducts.WixBusinessTest,
    DoppePremiumProducts.WixBusinessEliteTest,
    DoppePremiumProducts.WixLiteCore1,
    DoppePremiumProducts.WixLiteBusiness2,
    DoppePremiumProducts.WixLiteBusinessElite3,
    DoppePremiumProducts.WixLiteFreeTrialCore1,
    DoppePremiumProducts.WixLiteFreeTrialBusiness2,
    DoppePremiumProducts.WixLiteFreeTrialBusinessElite3,
    DoppePremiumProducts.WixLiteStarter1,
    DoppePremiumProducts.WixLiteWebsiteCheapFreeTrial2,
    DoppePremiumProducts.WixLiteBusinessCheapFreeTrial3,
    DoppePremiumProducts.WixLiteWebsiteMediumFreeTrial1,
    DoppePremiumProducts.WixLiteBusinessMediumFreeTrial2,
    DoppePremiumProducts.WixLiteBusinessEliteMediumFreeTrial3,

    DoppePremiumProducts.HoppNewFreeTrial7BrandShowcase,
    DoppePremiumProducts.HoppNewFreeTrial7BrandHigherPrice,
    DoppePremiumProducts.HoppNewFreeTrial7Brand,
    DoppePremiumProducts.HoppNewFreeTrial7Business,
    DoppePremiumProducts.HoppNewFreeTrial7BusinessPro,
    DoppePremiumProducts.HoppNewFreeTrial14Brand,
    DoppePremiumProducts.HoppNewFreeTrial14Business,
    DoppePremiumProducts.HoppNewFreeTrial14BusinessPro,

    DoppePremiumProducts.WixLiteStarterHigh,
    DoppePremiumProducts.WixLiteWebsiteHigh14,
    DoppePremiumProducts.WixLiteBusinessHigh14,
])

export type DoppeMainPremiumProducts = Values<typeof DoppeMainPremiumProducts>;

export const DoppePremiumBillingCycles = objectPick(WixPremiumBillingCycle, [
    'Monthly',
    'Yearly',
    'TwoYears'
]);

export type DoppePremiumBillingCycles = Values<typeof DoppePremiumBillingCycles>;

export type DoppePremiumBooleanFeatures = keyof PickByValue<typeof DoppePremiumFeaturesSpec, typeof WixPremiumFeatureType.Boolean>
export type DoppePremiumQuotaFeatures = keyof PickByValue<typeof DoppePremiumFeaturesSpec, typeof WixPremiumFeatureType.Quota>

export type DoppePremiumFeaturesStatus = WixPremiumFeaturesStatus<typeof DoppePremiumFeaturesSpec>

export function doppePremiumProductHasBillingCycleWithFreeDomainOffering(premiumProduct: DoppePremiumProducts) {
    switch (premiumProduct) {
        case DoppePremiumProducts.WixLiteStarter1_DONT_USE:
        case DoppePremiumProducts.Tier1_DONT_USE:
        case DoppePremiumProducts.FreeTrial14DaysBasic_DONT_USE:
        case DoppePremiumProducts.WixLiteStarter1:
        case DoppePremiumProducts.WixLiteStarterHigh:
        case DoppePremiumProducts.Tier1:
        case DoppePremiumProducts.HoppNewFreeTrial7BrandShowcase:
        case DoppePremiumProducts.FreeTrial14DaysBasic:
        case DoppePremiumProducts.NameComProTest:
        case DoppePremiumProducts.ProBrandMaker:
        case DoppePremiumProducts.Infinity:
        case DoppePremiumProducts.ProWithOutDomain: {
            return false;
        }
        case DoppePremiumProducts.HoppNewFreeTrialBrand_DONT_USE:
        case DoppePremiumProducts.HoppNewFreeTrialBusiness_DONT_USE:
        case DoppePremiumProducts.HoppNewFreeTrialBusinessPro_DONT_USE:
        case DoppePremiumProducts.WixLiteBusinessCheapFreeTrial3_DONT_USE:
        case DoppePremiumProducts.WixLiteBusinessEliteMediumFreeTrial3_DONT_USE:
        case DoppePremiumProducts.WixLiteBusinessMediumFreeTrial2_DONT_USE:
        case DoppePremiumProducts.WixLiteWebsiteCheapFreeTrial2_DONT_USE:
        case DoppePremiumProducts.WixLiteWebsiteMediumFreeTrial1_DONT_USE:
        case DoppePremiumProducts.Tier2_DONT_USE:
        case DoppePremiumProducts.Tier3_DONT_USE:
        case DoppePremiumProducts.FreeTrial14DaysUltimate_DONT_USE:
        case DoppePremiumProducts.FreeTrial14DaysVIP_DONT_USE:

        case DoppePremiumProducts.HoppNewFreeTrialBrand:
        case DoppePremiumProducts.HoppNewFreeTrial7BrandHigherPrice:
        case DoppePremiumProducts.WixLiteFreeTrialCore1:
        case DoppePremiumProducts.WixLiteFreeTrialBusiness2:
        case DoppePremiumProducts.WixLiteFreeTrialBusinessElite3:
        case DoppePremiumProducts.WixLiteCore1:
        case DoppePremiumProducts.WixLiteBusiness2:
        case DoppePremiumProducts.WixLiteBusinessElite3:
        case DoppePremiumProducts.WixLiteBusinessCheapFreeTrial3:
        case DoppePremiumProducts.WixLiteBusinessEliteMediumFreeTrial3:
        case DoppePremiumProducts.WixLiteBusinessMediumFreeTrial2:
        case DoppePremiumProducts.WixLiteWebsiteCheapFreeTrial2:
        case DoppePremiumProducts.WixLiteWebsiteMediumFreeTrial1:
        case DoppePremiumProducts.WixBusinessTest:
        case DoppePremiumProducts.WixBusinessEliteTest:
        case DoppePremiumProducts.ProBrandMakerWithDomain:
        case DoppePremiumProducts.IsracardVip:
        case DoppePremiumProducts.Pro:
        case DoppePremiumProducts.Starter:
        case DoppePremiumProducts.FreeTrial14DaysUltimate:
        case DoppePremiumProducts.FreeTrial14DaysVIP:
        case DoppePremiumProducts.HoppNewFreeTrialBusiness:
        case DoppePremiumProducts.HoppNewFreeTrialBusinessPro:
        case DoppePremiumProducts.Tier2:
        case DoppePremiumProducts.Tier3:
        case DoppePremiumProducts.HoppNewFreeTrial7Brand:
        case DoppePremiumProducts.HoppNewFreeTrial7Business:
        case DoppePremiumProducts.HoppNewFreeTrial7BusinessPro:
        case DoppePremiumProducts.HoppNewFreeTrial14Brand:
        case DoppePremiumProducts.HoppNewFreeTrial14Business:
        case DoppePremiumProducts.HoppNewFreeTrial14BusinessPro:
        case DoppePremiumProducts.WixLiteWebsiteHigh14:
        case DoppePremiumProducts.WixLiteBusinessHigh14:
        {
            return true;
        }
    }
}

export function doppePremiumHasSaleAndPaymentsOffering(
    premiumProduct: DoppePremiumProducts
) {
    switch (premiumProduct) {
        case DoppePremiumProducts.FreeTrial14DaysUltimate_DONT_USE:
        case DoppePremiumProducts.Tier2_DONT_USE:
        case DoppePremiumProducts.WixLiteWebsiteCheapFreeTrial2_DONT_USE:
        case DoppePremiumProducts.WixLiteWebsiteMediumFreeTrial1_DONT_USE:
        case DoppePremiumProducts.HoppNewFreeTrialBrand_DONT_USE:
        case DoppePremiumProducts.WixLiteStarter1_DONT_USE:
        case DoppePremiumProducts.Tier1_DONT_USE:
        case DoppePremiumProducts.FreeTrial14DaysBasic_DONT_USE:
        case DoppePremiumProducts.WixLiteStarter1:
        case DoppePremiumProducts.WixLiteStarterHigh:
        case DoppePremiumProducts.Tier1:
        case DoppePremiumProducts.FreeTrial14DaysBasic:
        case DoppePremiumProducts.NameComProTest:
        case DoppePremiumProducts.ProBrandMaker:
        case DoppePremiumProducts.Infinity:
        case DoppePremiumProducts.WixLiteCore1:
        case DoppePremiumProducts.WixLiteWebsiteCheapFreeTrial2:
        case DoppePremiumProducts.WixLiteWebsiteMediumFreeTrial1:
        case DoppePremiumProducts.HoppNewFreeTrialBrand:
        case DoppePremiumProducts.WixLiteFreeTrialCore1:
        case DoppePremiumProducts.Starter:
        case DoppePremiumProducts.Tier2:
        case DoppePremiumProducts.FreeTrial14DaysUltimate:
        case DoppePremiumProducts.HoppNewFreeTrial7Brand:
        case DoppePremiumProducts.WixLiteWebsiteHigh14:
        case DoppePremiumProducts.HoppNewFreeTrial14Brand:
        case DoppePremiumProducts.HoppNewFreeTrial7BrandHigherPrice:
        case DoppePremiumProducts.HoppNewFreeTrial7BrandShowcase:
        case DoppePremiumProducts.ProWithOutDomain: {
            return false;
        }
        case DoppePremiumProducts.HoppNewFreeTrialBusiness_DONT_USE:
        case DoppePremiumProducts.HoppNewFreeTrialBusinessPro_DONT_USE:
        case DoppePremiumProducts.WixLiteBusinessCheapFreeTrial3_DONT_USE:
        case DoppePremiumProducts.WixLiteBusinessEliteMediumFreeTrial3_DONT_USE:
        case DoppePremiumProducts.WixLiteBusinessMediumFreeTrial2_DONT_USE:
        case DoppePremiumProducts.Tier3_DONT_USE:
        case DoppePremiumProducts.FreeTrial14DaysVIP_DONT_USE:
        case DoppePremiumProducts.WixLiteFreeTrialBusiness2:
        case DoppePremiumProducts.WixLiteFreeTrialBusinessElite3:
        case DoppePremiumProducts.WixLiteBusiness2:
        case DoppePremiumProducts.WixLiteBusinessElite3:
        case DoppePremiumProducts.WixLiteBusinessCheapFreeTrial3:
        case DoppePremiumProducts.WixLiteBusinessEliteMediumFreeTrial3:
        case DoppePremiumProducts.WixLiteBusinessMediumFreeTrial2:
        case DoppePremiumProducts.WixBusinessTest:
        case DoppePremiumProducts.WixBusinessEliteTest:
        case DoppePremiumProducts.ProBrandMakerWithDomain:
        case DoppePremiumProducts.IsracardVip:
        case DoppePremiumProducts.Pro:
        case DoppePremiumProducts.FreeTrial14DaysVIP:
        case DoppePremiumProducts.HoppNewFreeTrialBusiness:
        case DoppePremiumProducts.HoppNewFreeTrialBusinessPro:
        case DoppePremiumProducts.Tier3:
        case DoppePremiumProducts.HoppNewFreeTrial7Business:
        case DoppePremiumProducts.HoppNewFreeTrial7BusinessPro:
        case DoppePremiumProducts.HoppNewFreeTrial14Business:
        case DoppePremiumProducts.HoppNewFreeTrial14BusinessPro:
        case DoppePremiumProducts.WixLiteBusinessHigh14:
        {
            return true;
        }
    }
}

export function doppePremiumHasFreeDomainOffering(
    premiumProduct: DoppePremiumProducts,
    doppePremiumBillingCycle: DoppePremiumBillingCycles
) {
    if (doppePremiumProductHasBillingCycleWithFreeDomainOffering(premiumProduct)) {
        switch (doppePremiumBillingCycle) {
            case DoppePremiumBillingCycles.Monthly: {
                return false;
            }
            case DoppePremiumBillingCycles.Yearly: {
                return true;
            }
            case DoppePremiumBillingCycles.TwoYears: {
                return true;
            }
        }
    } else {
        return false;
    }
}

export function doppePremiumBillingCycleResolveCycleInterval(doppePremiumBillingCycle: DoppePremiumBillingCycles) {
    return {
        intervalUnit: evaluateFunction(() => {
            switch (doppePremiumBillingCycle) {
                case DoppePremiumBillingCycles.TwoYears:
                    return WixPremiumCycleIntervalUnit.Year;
                case DoppePremiumBillingCycles.Yearly:
                    return WixPremiumCycleIntervalUnit.Year;
                case DoppePremiumBillingCycles.Monthly:
                    return WixPremiumCycleIntervalUnit.Month;
            }
        }),
        intervalCount: evaluateFunction(() => {
            switch (doppePremiumBillingCycle) {
                case DoppePremiumBillingCycles.TwoYears:
                    return 2;
                case DoppePremiumBillingCycles.Yearly:
                    return 1;
                case DoppePremiumBillingCycles.Monthly:
                    return 1;
            }
        })
    }
}

export function doppePremiumFeatureIsEnabled<F extends DoppePremiumBooleanFeatures>(
    premiumFeaturesStatus: DoppePremiumFeaturesStatus | null,
    feature: F
) {
    if (premiumFeaturesStatus === null) {
        return true;
    }

    return wixPremiumBooleanFeatureIsEnabled(premiumFeaturesStatus[feature] as WixPremiumFeatureStatus.BooleanFeature);
}

export function doppePremiumFeatureIsDisabled<F extends DoppePremiumBooleanFeatures>(
    premiumFeaturesStatus: DoppePremiumFeaturesStatus | null,
    feature: F
) {
    return !doppePremiumFeatureIsEnabled(premiumFeaturesStatus, feature);
}

export function doppePremiumFeatureHasFiniteRemainedQuota<F extends DoppePremiumQuotaFeatures>(
    premiumFeaturesStatus: DoppePremiumFeaturesStatus | null,
    feature: F
): boolean {
    return doppePremiumFeatureGetRemainedQuota(premiumFeaturesStatus, feature) < Infinity;
}

export function doppePremiumFeatureGetRemainedQuota<F extends DoppePremiumQuotaFeatures>(
    premiumFeaturesStatus: DoppePremiumFeaturesStatus | null,
    feature: F
): number {
    if (premiumFeaturesStatus === null) {
        return Infinity;
    }

    return wixPremiumQuotaFeatureGetRemainedQuota(premiumFeaturesStatus[feature] as WixPremiumFeatureStatus.QuotaFeature);
}

export function doppePremiumFeatureGetLimit<F extends DoppePremiumQuotaFeatures>(
    premiumFeaturesStatus: DoppePremiumFeaturesStatus | null,
    feature: F,
    defaultLimit?: number
): number {
    if (premiumFeaturesStatus === null) {
        return Infinity;
    }

    return wixPremiumQuotaFeatureGetLimit(premiumFeaturesStatus[feature] as WixPremiumFeatureStatus.QuotaFeature, defaultLimit);
}


export function doppePremiumGetBooleanFeatures() {
    return objectGetKeys(
        objectFilterEntries(DoppePremiumFeaturesSpec, featureType => featureType === WixPremiumFeatureType.Boolean)
    ) as DoppePremiumBooleanFeatures[];
}

export function doppePremiumGetQuotaFeatures() {
    return objectGetKeys(
        objectFilterEntries(DoppePremiumFeaturesSpec, featureType => featureType === WixPremiumFeatureType.Quota)
    ) as DoppePremiumQuotaFeatures[];
}

export function doppePremiumIsActive(featuresStatus: DoppePremiumFeaturesStatus) {
    return doppePremiumFeatureIsEnabled(featuresStatus, DoppePremiumActiveDistinguishingFeature);
}

export function doppePremiumGetLongestSupportedBillingCycle() {
    if (enumIsEnumValue(DoppePremiumBillingCycles, WixPremiumBillingCycle.TwoYears)) {
        return WixPremiumBillingCycle.TwoYears;
    } else {
        return WixPremiumBillingCycle.Yearly;
    }
}

export function doppePremiuIsPackageConsistsAllFeatures(
    premiumProduct: DoppePremiumProducts,
    featuresToCheck: DoppeDtoPremiumFeatureCatalogInfo[],
    featuresByProduct: Record<DoppePremiumProducts, DoppeDtoPremiumFeatureCatalogInfo[]>
) {

    let allExists = true;
    let featureToCheckIndex = 0

    while (allExists && featureToCheckIndex < featuresToCheck.length) {
        const featureToCheck = featuresToCheck[featureToCheckIndex];

        if (featuresByProduct[premiumProduct].find(feature => {

            if (feature.uniqueName === featureToCheck.uniqueName) {
                if (feature.type === 'quota' && featureToCheck.type === 'quota') {
                    return (feature.limit === null ? Infinity : feature.limit?.low ?? 1) > (featureToCheck.limit?.low ?? 0)
                } else {
                    return true;
                }
            }

            return false;
        }) === undefined) {
            allExists = false;
        }

        featureToCheckIndex++;
    }


    return allExists;
}

export function doppeIsQuotaFeature(
    premiumProduct: DoppePremiumProducts,
    featureToCheck: string,
    featuresByProduct: Record<DoppePremiumProducts, DoppeDtoPremiumFeatureCatalogInfo[]>
) {

    const feature = featuresByProduct[premiumProduct].find(feature => {
        if (feature.uniqueName === featureToCheck) {
            return true
        }
        return false;
    })

    if (feature?.type === 'quota') {
        return true
    } else {
        return false;
    }
}

export function doppeGetQuotaFeatureLimit(
    premiumProduct: DoppePremiumProducts,
    featureToCheck: string,
    featuresByProduct: Record<DoppePremiumProducts, DoppeDtoPremiumFeatureCatalogInfo[]>
) {

    const feature = featuresByProduct[premiumProduct].find(feature => {
        if (feature.uniqueName === featureToCheck) {
            return true
        }
        return false;
    })

    if (feature?.type === 'quota') {
        return feature?.limit?.low;
    } else {
        return null;
    }
}


export function doppeGetPremiumProductsDiscounts(
    premiumProductsPricing: WixPremiumProductsPricing<WixPremiumProductId, DoppePremiumBillingCycles> | null
) {
    const packagesArray = premiumProductsPricing?.productsPricingData ? objectGetValues(premiumProductsPricing?.productsPricingData) : [];
    const packagesArrayDiscounts = packagesArray.map(packageDetails => packageDetails.YEARLY.discountPercentage ?? 0).filter(sale => sale > 0);

    const minSale = packagesArrayDiscounts.length > 0 ? (Math.min(...packagesArrayDiscounts, Infinity) ?? 0) : 0;
    const maxSale = packagesArrayDiscounts.length > 0 ? (Math.max(...packagesArrayDiscounts, 0) ?? 0) : 0;

    return {
        minSale,
        maxSale
    }
}

export function doppeGetMinPricePremiumProductWithDiscount(
    premiumProductsPricing: WixPremiumProductsPricing<WixPremiumProductId, DoppePremiumBillingCycles> | null
) {
    const packagesArray = premiumProductsPricing?.productsPricingData ? objectGetValues(premiumProductsPricing?.productsPricingData) : [];
    const packagesArrayDiscounts = packagesArray.map(packageDetails => packageDetails.YEARLY.discountPrice).filter(discountPrice => discountPrice !== null && discountPrice > 0) as number[];

    const minPrice = packagesArrayDiscounts.length > 0 ? (Math.min(...packagesArrayDiscounts, Infinity) ?? 0) : 0;
    const record = objectFilterEntries(premiumProductsPricing?.productsPricingData ?? {}, (packageDetails) => {
        return packageDetails?.YEARLY.discountPrice === minPrice
    })

    return objectGetKeys(record)[0] ?? null;
}




